<!--
 * Created Date: 2020-07-15 5:40:11 PM
 * Author: Liu Man <lm@hcttop.com>
 * -----
 * Last Modified: 2020-07-15, 5:40:11 PM
 * Modified By: Liu Man <lm@hcttop.com>
 * -----
 * Copyright (c) 2020-2020 hcttop
 * -----
 * HISTORY:
 * Date               By    Comments
 * ------------------ ----  ---------------------------------------------
 -->

<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
